module.exports = __webpack_public_path__ + "img/sz.f1502f65.svg";